module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "upload-img"
  }, [_c('el-upload', {
    ref: "upload",
    staticClass: "upload-demo",
    attrs: {
      "accept": "image/*",
      "on-success": _vm.handleSuccess,
      "before-upload": _vm.beforeUpload,
      "file-list": _vm.fileList,
      "list-type": "picture-card",
      "limit": _vm.limit,
      "on-exceed": _vm.handleExeccd,
      "on-remove": _vm.handleRemove
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    }
  }, [_c('span', [_vm._v("点击上传")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.limit > 1),
      expression: "limit>1"
    }],
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v(_vm._s(_vm.fileStore.length) + "/" + _vm._s(_vm.limit) + _vm._s(_vm.tips))])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.1.0@vue-loader/lib/template-compiler?{"id":"data-v-21e209d0"}!./~/_vue-loader@12.1.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/Enterprise/enterpriseMent/src/imgUpload.vue
// module id = 1431
// module chunks = 1